import { DeviceGroupStyleProperties } from './types';

export const colorMapping: DeviceGroupStyleProperties[] = [
  {
    bg: 'bg-fuschia-50',
    fill: 'fill-fuschia-50',
    raw: 'fuschia-50',
    stroke: 'stroke-fuschia-70',
  },
  {
    bg: 'bg-orange-50',
    fill: 'fill-orange-50',
    raw: 'orange-50',
    stroke: 'stroke-orange-70',
  },
  {
    bg: 'bg-purple-50',
    fill: 'fill-purple-50',
    raw: 'purple-50',
    stroke: 'stroke-purple-70',
  },
  {
    bg: 'bg-cyan-50',
    fill: 'fill-cyan-50',
    raw: 'cyan-50',
    stroke: 'stroke-cyan-70',
  },
  {
    bg: 'bg-blue-50',
    fill: 'fill-blue-50',
    raw: 'blue-50',
    stroke: 'stroke-blue-70',
  },
  {
    bg: 'bg-yellow-50',
    fill: 'fill-yellow-50',
    raw: 'yellow-50',
    stroke: 'stroke-yellow-70',
  },
];
